export class LoginRequestDTO {
    userName: string;
    password: string;
}